import { useIntl } from 'umi';
import RTCModel from '@/models/rtc';
import { inject, observer } from 'mobx-react';
import React, { useState } from 'react';
import { useMemo } from 'react';
import { Icon, Select } from '@/components';
import Style from './index.less';
import './select.less';
import { SelectOption } from '@/components/Select';

interface CheckProps {
  RTCInstance?: RTCModel;
  title: string;
  options: SelectOption[];
  selectLabel: string;
  levelLabel: string;
  onChange: (value: string) => void;
  device: string;
  deviceVolume: number;
  maxVolume: number;
}

const DeviceCheck: React.FC<CheckProps> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
  };
})(
  observer(props => {
    const { RTCInstance, title, options, selectLabel, levelLabel, onChange, device, deviceVolume, maxVolume } = props;
    const { formatMessage } = useIntl();
    // const [level, setLevel] = useState(10);
    const chosenDeviceIdx = device === 'default' ? 0 : options.findIndex(item => item.value === device);
    return (
      <div className={Style['device-check']}>
        <div className={Style.title}>{formatMessage({ id: title })}</div>
        <div className={Style.choose}>
          <div className={Style.label}>
            <span>{formatMessage({ id: selectLabel })}</span>
            <span>
              {formatMessage(
                { id: 'TESTING_NTH_WITH_TOTAL_NUM' },
                {
                  number: chosenDeviceIdx + 1,
                  total: options?.length,
                },
              )}
            </span>
          </div>
          <div className={Style.select}>
            <Select
              onChange={onChange}
              value={device}
              options={options}
              className={Style['select-content']}
              suffixIcon={<Icon name="icon-jiantou" />}
              dropdownClassName={Style['select-dropdown']}
            />
          </div>
        </div>
        <div className={Style.level}>
          <div>{formatMessage({ id: levelLabel })}</div>
          <div>
            {Array(15)
              .fill(1)
              .map((_, idx) => (
                <Icon
                  name="icon-shuchujibie"
                  size={20}
                  key={idx}
                  // onClick={() => {
                  //   onVolumeChange(idx);
                  //   setLevel(idx);
                  // }}
                  style={
                    idx === Math.floor(maxVolume * 14) || idx < deviceVolume * 14
                      ? { color: 'rgba(255,255,255,0.6)' }
                      : {}
                  }
                />
              ))}
          </div>
        </div>
      </div>
    );
  }),
);

export default DeviceCheck;
